<div class="subBlockContainer componentContainer">
  <div class="subBlockContent componentContent">
    <div class="inner-subBlock-wrapper">
      <div class="page-title-wrapper">
        <div class="page-title-position">
          {{title}} - {{reportType}}
        </div>
        <i class="material-icons pullfloat-right" (click)="close()">close</i>
      </div>
      <div class="top-divider"></div>
      <div class="inner-subBlock-wrapper">
          <div class="sub-container">
            <div class="row">
              <div>
                <span class="heading">FREQUENCY:</span>
                <select [(ngModel)]="schedule.frequency" class="form-control quote-select" (change)="updateEndDate()">
                  <option *ngFor="let freq of schedulingFreq">
                    {{freq}}
                  </option>
                </select>
              </div>
            </div>
            <!-- ADD in the SPECIFICS depending on FREQUENCY -->
            <div class="row middle">
              <!-- make centred box which holds all the specifics -->
              <div *ngIf="schedule?.frequency!='DOWNLOAD NOW'" class="settings-container">
                <div *ngIf="schedule?.frequency=='ONCE'" class="setting-sub-container">
                  <!-- DATE + TIME -->
                  <div class="input-control text">
                    <label>EMAIL DATE:</label>
                    <input id="textOnceDate" [(ngModel)]="schedule.onceDate" appCalendar (dateSelected)="schedule.onceDate=$event">
                  </div>
                </div>
                <div *ngIf="schedule?.frequency=='WEEKLY'" class="setting-sub-container">
                  <!-- DAYS OF WEEK -->
                  <div>
                    <label>DAYS OF WEEK:</label>
                    <div style="margin: 10px 0;">
                      <div class="row">
                        <div class="input-control checkBox">
                            <input id="chkBoxMon" [(ngModel)]="schedule.daysOfWeek[0]" type="checkbox">
                            <label for="chkBoxMon">MONDAY</label>
                        </div>
                        <div class="input-control checkBox">
                            <input id="chkBoxTue" [(ngModel)]="schedule.daysOfWeek[1]" type="checkbox">
                            <label for="chkBoxTue">TUESDAY</label>
                        </div>
                        <div class="input-control checkBox">
                            <input id="chkBoxWed" [(ngModel)]="schedule.daysOfWeek[2]" type="checkbox">
                            <label for="chkBoxWed">WEDNESDAY</label>
                        </div>
                        <div class="input-control checkBox">
                            <input id="chkBoxThu" [(ngModel)]="schedule.daysOfWeek[3]" type="checkbox">
                            <label for="chkBoxThu">THURSDAY</label>
                        </div>
                      </div>
                      <div class="row">
                        <div class="input-control checkBox">
                            <input id="chkBoxFri" [(ngModel)]="schedule.daysOfWeek[4]" type="checkbox">
                            <label for="chkBoxFri">FRIDAY</label>
                        </div>
                        <div class="input-control checkBox">
                            <input id="chkBoxSat" [(ngModel)]="schedule.daysOfWeek[5]" type="checkbox">
                            <label for="chkBoxSat">SATURDAY</label>
                        </div>
                        <div class="input-control checkBox">
                            <input id="chkBoxSun" [(ngModel)]="schedule.daysOfWeek[6]" type="checkbox">
                            <label for="chkBoxSun">SUNDAY</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div *ngIf="schedule?.frequency=='MONTHLY'" class="setting-sub-container">
                  <!-- DAY OF MONTH + TIME -->
                  <div class="row">
                      <div class="input-control radio">
                          <input id="radioDay" [(ngModel)]="schedule.monthSetting" type="radio" value="DAY">
                          <label for="radioDay">SPECIFIC DAYS</label>
                      </div>
                      <div class="input-control radio">
                          <input id="radioWeek" [(ngModel)]="schedule.monthSetting" type="radio" value="WEEK">
                          <label for="radioWeek">DAY OF WEEK</label>
                      </div>
                  </div>
                  <div *ngIf="schedule?.monthSetting=='DAY'">
                    <label>DAYS:</label>
                    <div class="row">
                        <div class="input-control checkBox">
                            <input id="chkBox1" [(ngModel)]="schedule.daysOfMonth[1]" type="checkBox">
                            <label for="chkBox1">01</label>
                        </div>
                        <div class="input-control checkBox">
                            <input id="chkBox2" [(ngModel)]="schedule.daysOfMonth[2]" type="checkBox">
                            <label for="chkBox2">02</label>
                        </div>
                        <div class="input-control checkBox">
                            <input id="chkBox3" [(ngModel)]="schedule.daysOfMonth[3]" type="checkBox">
                            <label for="chkBox3">03</label>
                        </div>
                        <div class="input-control checkBox">
                            <input id="chkBox4" [(ngModel)]="schedule.daysOfMonth[4]" type="checkBox">
                            <label for="chkBox4">04</label>
                        </div>
                        <div class="input-control checkBox">
                            <input id="chkBox5" [(ngModel)]="schedule.daysOfMonth[5]" type="checkBox">
                            <label for="chkBox5">05</label>
                        </div>
                        <div class="input-control checkBox">
                            <input id="chkBox6" [(ngModel)]="schedule.daysOfMonth[6]" type="checkBox">
                            <label for="chkBox6">06</label>
                        </div>
                        <div class="input-control checkBox">
                            <input id="chkBox7" [(ngModel)]="schedule.daysOfMonth[7]" type="checkBox">
                            <label for="chkBox7">07</label>
                        </div>
                        <div class="input-control checkBox">
                            <input id="chkBox8" [(ngModel)]="schedule.daysOfMonth[8]" type="checkBox">
                            <label for="chkBox8">08</label>
                        </div>
                        <div class="input-control checkBox">
                            <input id="chkBox9" [(ngModel)]="schedule.daysOfMonth[9]" type="checkBox">
                            <label for="chkBox9">09</label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="input-control checkBox">
                            <input id="chkBox10" [(ngModel)]="schedule.daysOfMonth[10]" type="checkBox">
                            <label for="chkBox10">10</label>
                        </div>
                        <div class="input-control checkBox">
                            <input id="chkBox11" [(ngModel)]="schedule.daysOfMonth[11]" type="checkBox">
                            <label for="chkBox11">11</label>
                        </div>
                        <div class="input-control checkBox">
                            <input id="chkBox12" [(ngModel)]="schedule.daysOfMonth[12]" type="checkBox">
                            <label for="chkBox12">12</label>
                        </div>
                        <div class="input-control checkBox">
                            <input id="chkBox13" [(ngModel)]="schedule.daysOfMonth[13]" type="checkBox">
                            <label for="chkBox13">13</label>
                        </div>
                        <div class="input-control checkBox">
                            <input id="chkBox14" [(ngModel)]="schedule.daysOfMonth[14]" type="checkBox">
                            <label for="chkBox14">14</label>
                        </div>
                        <div class="input-control checkBox">
                            <input id="chkBox15" [(ngModel)]="schedule.daysOfMonth[15]" type="checkBox">
                            <label for="chkBox15">15</label>
                        </div>
                        <div class="input-control checkBox">
                            <input id="chkBox16" [(ngModel)]="schedule.daysOfMonth[16]" type="checkBox">
                            <label for="chkBox16">16</label>
                        </div>
                        <div class="input-control checkBox">
                            <input id="chkBox17" [(ngModel)]="schedule.daysOfMonth[17]" type="checkBox">
                            <label for="chkBox17">17</label>
                        </div>
                        <div class="input-control checkBox">
                            <input id="chkBox18" [(ngModel)]="schedule.daysOfMonth[18]" type="checkBox">
                            <label for="chkBox18">18</label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="input-control checkBox">
                            <input id="chkBox19" [(ngModel)]="schedule.daysOfMonth[19]" type="checkBox">
                            <label for="chkBox19">19</label>
                        </div>
                        <div class="input-control checkBox">
                            <input id="chkBox20" [(ngModel)]="schedule.daysOfMonth[20]" type="checkBox">
                            <label for="chkBox20">20</label>
                        </div>
                        <div class="input-control checkBox">
                              <input id="chkBox21" [(ngModel)]="schedule.daysOfMonth[21]" type="checkBox">
                              <label for="chkBox21">21</label>
                          </div>
                          <div class="input-control checkBox">
                              <input id="chkBox22" [(ngModel)]="schedule.daysOfMonth[22]" type="checkBox">
                              <label for="chkBox22">22</label>
                          </div>
                          <div class="input-control checkBox">
                              <input id="chkBox23" [(ngModel)]="schedule.daysOfMonth[23]" type="checkBox">
                              <label for="chkBox23">23</label>
                          </div>
                          <div class="input-control checkBox">
                              <input id="chkBox24" [(ngModel)]="schedule.daysOfMonth[24]" type="checkBox">
                              <label for="chkBox24">24</label>
                          </div>
                          <div class="input-control checkBox">
                              <input id="chkBox25" [(ngModel)]="schedule.daysOfMonth[25]" type="checkBox">
                              <label for="chkBox25">25</label>
                          </div>
                          <div class="input-control checkBox">
                              <input id="chkBox26" [(ngModel)]="schedule.daysOfMonth[26]" type="checkBox">
                              <label for="chkBox26">26</label>
                          </div>
                          <div class="input-control checkBox">
                              <input id="chkBox27" [(ngModel)]="schedule.daysOfMonth[27]" type="checkBox">
                              <label for="chkBox27">27</label>
                          </div>
                    </div>
                    <div class="row">
                        <div class="input-control checkBox">
                            <input id="chkBox28" [(ngModel)]="schedule.daysOfMonth[28]" type="checkBox">
                            <label for="chkBox28">28</label>
                        </div>
                        <div class="input-control checkBox">
                            <input id="chkBox29" [(ngModel)]="schedule.daysOfMonth[29]" type="checkBox">
                            <label for="chkBox29">29</label>
                        </div>
                        <div class="input-control checkBox">
                            <input id="chkBox30" [(ngModel)]="schedule.daysOfMonth[30]" type="checkBox">
                            <label for="chkBox30">30</label>
                        </div>
                        <div class="input-control checkBox">
                            <input id="chkBox31" [(ngModel)]="schedule.daysOfMonth[31]" type="checkBox">
                            <label for="chkBox31">31</label>
                        </div>
                        <div class="input-control checkBox">
                            <input id="chkBoxLast" [(ngModel)]="schedule.daysOfMonth[0]" type="checkBox">
                            <label for="chkBoxLast">LAST</label>
                        </div>
                    </div>
                  </div>
                  <div *ngIf="schedule?.monthSetting=='WEEK'">
                    <label>ON:</label>
                    <div class="row">
                      <div class="input-control checkBox">
                        <input id="chkBoxFirst" [(ngModel)]="schedule.monthSpecifics[0]" type="checkbox">
                        <label for="chkBoxFirst">FIRST</label>
                      </div>
                      <div class="input-control checkBox">
                        <input id="chkBoxSecond" [(ngModel)]="schedule.monthSpecifics[1]" type="checkbox">
                        <label for="chkBoxSecond">SECOND</label>
                      </div>
                      <div class="input-control checkBox">
                        <input id="chkBoxThird" [(ngModel)]="schedule.monthSpecifics[2]" type="checkbox">
                        <label for="chkBoxThird">THIRD</label>
                      </div>
                      <div class="input-control checkBox">
                        <input id="chkBoxFourth" [(ngModel)]="schedule.monthSpecifics[3]" type="checkbox">
                        <label for="chkBoxFourth">FOURTH</label>
                      </div>
                      <div class="input-control checkBox">
                        <input id="chkBox-Last" [(ngModel)]="schedule.monthSpecifics[4]" type="checkbox">
                        <label for="chkBox-Last">LAST</label>
                      </div>
                    </div>
                    <label>DAY OF WEEK:</label>
                    <div class="row">
                      <div class="input-control checkBox">
                        <input id="chkBoxMon2" [(ngModel)]="schedule.daysOfWeek[0]" type="checkbox">
                        <label for="chkBoxMon2">MONDAY</label>
                      </div>
                      <div class="input-control checkBox">
                        <input id="chkBoxTue2" [(ngModel)]="schedule.daysOfWeek[1]" type="checkbox">
                        <label for="chkBoxTue2">TUESDAY</label>
                      </div>
                      <div class="input-control checkBox">
                        <input id="chkBoxWed2" [(ngModel)]="schedule.daysOfWeek[2]" type="checkbox">
                        <label for="chkBoxWed2">WEDNESDAY</label>
                      </div>
                      <div class="input-control checkBox">
                        <input id="chkBoxThu2" [(ngModel)]="schedule.daysOfWeek[3]" type="checkbox">
                        <label for="chkBoxThu2">THURSDAY</label>
                      </div>
                    </div>
                    <div class="row">
                      <div class="input-control checkBox">
                        <input id="chkBoxFri2" [(ngModel)]="schedule.daysOfWeek[4]" type="checkbox">
                        <label for="chkBoxFri2">FRIDAY</label>
                      </div>
                      <div class="input-control checkBox">
                        <input id="chkBoxSat2" [(ngModel)]="schedule.daysOfWeek[5]" type="checkbox">
                        <label for="chkBoxSat2">SATURDAY</label>
                      </div>
                      <div class="input-control checkBox">
                        <input id="chkBoxSun2" [(ngModel)]="schedule.daysOfWeek[6]" type="checkbox">
                        <label for="chkBoxSun2">SUNDAY</label>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <div *ngIf="frequency!=''" class="setting-sub-container">
                  <div>
                    <label>START TIME:</label>
                    <ngb-timepicker [(ngModel)]="startTime"></ngb-timepicker>
                  </div>
                  <div>
                    <label>END TIME:</label>
                    <ngb-timepicker [(ngModel)]="endTime"></ngb-timepicker>
                  </div>
                </div> -->
              </div>
            </div>
            <!-- START and END dates of the download -->
            <div *ngIf="schedule?.frequency!='ONCE' && schedule?.frequency!='DOWNLOAD NOW'" class="row">
              <span  class="input-control text">
                <label>FROM:</label>
                <input id="textStartDate" [(ngModel)]="schedule.startDate" appCalendar (dateSelected)="schedule.startDate=$event">
              </span>
              <span class="input-control text" style="margin-left: 10px;">
                <label>TO:</label>
                <input id="textEndDate" [(ngModel)]="schedule.endDate" appCalendar (dateSelected)="schedule.endDate=$event">
              </span>
            </div>
          </div>
          <div class="button-container">
            <button id="nextButton" class="button button-red button-small" (click)="continue()">Next</button>
          </div>
      </div>      
    </div>
  </div>
</div>
<ng-template #summary></ng-template>
